import { render, staticRenderFns } from "./index_two.vue?vue&type=template&id=2edc81da&scoped=true&"
import script from "./index_two.vue?vue&type=script&lang=js&"
export * from "./index_two.vue?vue&type=script&lang=js&"
import style0 from "./index_two.vue?vue&type=style&index=0&id=2edc81da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edc81da",
  null
  
)

export default component.exports